namespace TabAurous.Retail {
    export interface POSSalesWithoutTaxRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        AutoPosting?: boolean;
        PartyId?: number;
        POSCustomerId?: number;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        RoundOff?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        GSTState?: string;
        ItemDetails?: POSSalesItemsRow[];
        GiftDetails?: POSSalesGiftVoucherRow[];
        ReceiptDetails?: POSSalesReceiptRow[];
        PromoDetails?: PosSalesPromoRow[];
        PosCustomerCode?: string;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        ImageName?: string;
        Receipt?: number;
        BalanceAmount?: number;
        CustomerName?: string;
        Email?: string;
        BirthDate?: string;
        Anniversary?: string;
        TaxId?: string;
        PanNumber?: string;
        Address?: string;
        Mobile?: string;
        PostingDate?: string;
        IsPosted?: boolean;
        Username?: string;
    }

    export namespace POSSalesWithoutTaxRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Retail.POSSalesWithoutTax';
        export const deletePermission = 'Retail:POSSalesWithoutTax:Delete';
        export const insertPermission = 'Retail:POSSalesWithoutTax:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:POSSalesWithoutTax:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            AutoPosting = "AutoPosting",
            PartyId = "PartyId",
            POSCustomerId = "POSCustomerId",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            RoundOff = "RoundOff",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            GSTState = "GSTState",
            ItemDetails = "ItemDetails",
            GiftDetails = "GiftDetails",
            ReceiptDetails = "ReceiptDetails",
            PromoDetails = "PromoDetails",
            PosCustomerCode = "PosCustomerCode",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            ImageName = "ImageName",
            Receipt = "Receipt",
            BalanceAmount = "BalanceAmount",
            CustomerName = "CustomerName",
            Email = "Email",
            BirthDate = "BirthDate",
            Anniversary = "Anniversary",
            TaxId = "TaxId",
            PanNumber = "PanNumber",
            Address = "Address",
            Mobile = "Mobile",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            Username = "Username"
        }
    }
}
